export default __webpack_public_path__ + "static/media/Nik.26a019f3.png";